import styled from "styled-components";

export const SWebhookEditButtonWrapper = styled.div`
  margin-left: auto;
`;
